"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";
import { BILLING_CYCLE_OPTIONS, type BillingCycle } from "./pricingPageCopy";

type BillingCycleToggleProps = {
  defaultValue?: BillingCycle;
  onChange: (cycle: BillingCycle) => void;
};

export function BillingCycleToggle({
  defaultValue = "semester",
  onChange,
}: BillingCycleToggleProps) {
  const [value, setValue] = useState<BillingCycle>(defaultValue);

  function selectCycle(cycle: BillingCycle) {
    setValue(cycle);
    onChange(cycle);
  }

  return (
    <div
      className="inline-flex w-full max-w-[430px] rounded-full border border-slate-200 bg-white p-1.5 shadow-[0_18px_48px_-34px_rgba(15,23,42,0.52)] ring-1 ring-slate-100"
      role="group"
      aria-label="Billing cycle"
    >
      {BILLING_CYCLE_OPTIONS.map((option) => {
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => selectCycle(option.value)}
            className={cn(
              "flex min-h-[62px] flex-1 flex-col items-center justify-center rounded-full px-4 text-center transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700",
              isActive
                ? "bg-slate-950 text-white shadow-[0_16px_28px_-20px_rgba(15,23,42,0.92)]"
                : "text-slate-600 hover:bg-slate-50 hover:text-slate-950",
            )}
          >
            <span className="text-base font-black leading-tight">{option.label}</span>
            <span
              className={cn(
                "mt-1 text-[12px] font-bold leading-tight",
                isActive ? "text-white/80" : "text-slate-500",
              )}
            >
              {option.subtext}
            </span>
          </button>
        );
      })}
    </div>
  );
}
